export default {
  borderPadding: '2.5rem 3rem',
  smallMobileBorderPadding: '2.5rem 2rem',
  navListWidth: '300px',
};
